import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VideoCtx = createContext({ videos: {}, loading: true });

export function VideosProvider({ children }) {
  const [videos, setVideos] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/videos`)
      .then((res) => { if (!cancelled) setVideos(res.data || {}); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return <VideoCtx.Provider value={{ videos, loading }}>{children}</VideoCtx.Provider>;
}

export function useVideo(key) {
  const { videos, loading } = useContext(VideoCtx);
  return { youtubeId: videos[key] || "", loading };
}
